export default class RegisterKeycode {
  change() {
    // if($('#check_register_user').is(":checked")){
    RegisterPage.activeBtnUser();
    // }
  }
}
